import React, { FC, useContext } from 'react';
import * as Styled from './HeaderContainer.styles';
import { GalleryContext } from '../../hooks/useGalleryContext';

interface HeaderContainerProps {
  show: boolean;
  children: React.ReactNode;
  backgroundColor?: string;
}

export const HeaderContainer: FC<HeaderContainerProps> = ({
  show,
  children,
  backgroundColor,
}) => {
  const { fullScreenActive } = useContext(GalleryContext);
  return (
    <Styled.Wrapper
      backgroundColor={backgroundColor}
      show={show}
      isFullscreenOpen={fullScreenActive}
    >
      <Styled.Content>{children}</Styled.Content>
    </Styled.Wrapper>
  );
};
